import React from "react";
import { Card } from "react-bootstrap";
import "./Rocket.css";

function Rocket({ details }) {
  const {
    flight_number,
    mission_name,
    mission_id,
    launch_year,
    launch_success,
    links,
    rocket,
  } = details;
  const imgSrc = links.mission_patch_small;
  const land_success = rocket.first_stage.cores[0].land_success;

  return (
    <Card className="Rocket-card">
      <div key={flight_number}>
        <div>
          <img
            src={imgSrc}
            alt=" "
            className="Rocket-image"
          />
        </div>
        <div className="Rocket-name-flight-number">
          {mission_name} #{flight_number}
        </div>
        <div className="Rocket-label">
          Mission Ids:{" "}
          <ul>
            {" "}
            <li className="Rocket-value">{mission_id}</li>
          </ul>
        </div>
        <div className="Rocket-label">
          Launch Year:{" "}
          <span className="Rocket-value">{launch_year}</span>
        </div>
        <div className="Rocket-label">
          Successful Launch:{" "}
          <span className="Rocket-value">
            {launch_success ? "true" : "false"}
          </span>
        </div>
        <div className="Rocket-label">
          Successful Landing:{" "}
          <span className="Rocket-value">
            {land_success ? "true" : "false"}
          </span>
        </div>
      </div>
    </Card>
  );
}

export default Rocket;
